import { render } from "./certificat_list.vue?vue&type=template&id=3628f3ac&scoped=true"
import script from "./certificat_list.vue?vue&type=script&lang=js"
export * from "./certificat_list.vue?vue&type=script&lang=js"

import "./certificat_list.vue?vue&type=style&index=0&id=3628f3ac&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\inner-training\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3628f3ac"]])

export default __exports__